module.exports = __webpack_public_path__ + "assets_app/img/key_go.c8d93a4e.svg";